export const heroArticles = [
  {
    id: '1',
    title: '某顶流网红深夜发长文道歉，承认与多位女粉丝存在不当关系',
    category: '网红爆料',
    imageUrl: 'https://readdy.ai/api/search-image?query=dark%20moody%20entertainment%20news%20studio%20scene%20with%20dramatic%20spotlight%20on%20microphone%2C%20intense%20atmosphere%2C%20gossip%20media%20broadcast%20setting%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20warm%20tone%20accents%2C%20professional%20newsroom%20aesthetic%2C%20high%20contrast%20photography%2C%20editorial%20style&width=1600&height=900&seq=hero-main-01&orientation=landscape',
    date: '2026-07-07',
    views: '128.6万',
    comments: '3.2万',
    excerpt: '近日，知名网红在社交平台发布长文，就此前被曝光的私生活问题向公众道歉，引发全网热议。'
  },
  {
    id: '2',
    title: '娱乐圈再爆大瓜！某知名女星被拍到深夜密会神秘男子',
    category: '明星黑料',
    imageUrl: 'https://readdy.ai/api/search-image?query=paparazzi%20style%20night%20street%20scene%20with%20blurred%20figures%20and%20dramatic%20lighting%2C%20entertainment%20gossip%20photography%2C%20dark%20urban%20setting%20with%20neon%20reflections%2C%20warm%20amber%20tone%20overlay%2C%20mysterious%20atmosphere%2C%20editorial%20celebrity%20news%20style&width=800&height=600&seq=hero-side-02&orientation=landscape',
    date: '2026-07-06',
    views: '96.3万',
    comments: '2.8万',
    excerpt: '据知情人士透露，两人已秘密交往数月，男方身份成谜。'
  },
  {
    id: '3',
    title: '直播带货翻车现场！大主播涉嫌虚假宣传被粉丝集体投诉',
    category: '直播翻车',
    imageUrl: 'https://readdy.ai/api/search-image?query=live%20streaming%20studio%20setup%20with%20dramatic%20red%20warning%20lighting%2C%20modern%20broadcast%20equipment%20on%20desk%2C%20tense%20atmosphere%2C%20social%20media%20controversy%20concept%2C%20warm%20crimson%20tones%2C%20editorial%20photography%20style%2C%20clean%20background&width=800&height=600&seq=hero-side-03&orientation=landscape',
    date: '2026-07-05',
    views: '85.7万',
    comments: '2.1万',
    excerpt: '消费者协会已介入调查，涉事主播账号目前已被平台暂时封禁。'
  }
];

export const matrixArticles = [
  {
    id: 'm1',
    title: '某短视频平台大V被曝学历造假，名校光环竟是包装出来的',
    category: '网红打假',
    imageUrl: 'https://readdy.ai/api/search-image?query=investigation%20journalism%20scene%20with%20documents%20and%20magnifying%20glass%20on%20dark%20wooden%20desk%2C%20warm%20lighting%20from%20desk%20lamp%2C%20mysterious%20atmosphere%2C%20professional%20detective%20aesthetic%2C%20editorial%20photography%2C%20clean%20simple%20background%2C%20high%20detail&width=800&height=600&seq=matrix-01&orientation=landscape',
    date: '2026-07-07',
    views: '45.2万',
    comments: '1.8万'
  },
  {
    id: 'm2',
    title: '深夜重磅！某选秀出道偶像被前女友曝光出轨证据',
    category: '偶像塌房',
    imageUrl: 'https://readdy.ai/api/search-image?query=shattered%20heart%20concept%20with%20dark%20dramatic%20lighting%2C%20emotional%20breakup%20scene%2C%20warm%20amber%20and%20crimson%20color%20palette%2C%20artistic%20editorial%20photography%2C%20soft%20focus%20background%2C%20clean%20minimal%20composition%2C%20high%20emotional%20impact&width=800&height=600&seq=matrix-02&orientation=landscape',
    date: '2026-07-06',
    views: '67.8万',
    comments: '2.5万'
  },
  {
    id: 'm3',
    title: '某知名美食博主被实锤：所谓的探店全是付费推广',
    category: '博主揭秘',
    imageUrl: 'https://readdy.ai/api/search-image?query=food%20photography%20studio%20setup%20with%20professional%20camera%20and%20lighting%20equipment%2C%20behind%20the%20scenes%20of%20food%20blogging%2C%20warm%20natural%20lighting%2C%20clean%20modern%20kitchen%20background%2C%20editorial%20style%2C%20high%20detail%2C%20soft%20shadows&width=800&height=600&seq=matrix-03&orientation=landscape',
    date: '2026-07-05',
    views: '38.5万',
    comments: '1.2万'
  },
  {
    id: 'm4',
    title: '电竞圈大地震！知名选手被俱乐部解约内幕曝光',
    category: '电竞黑料',
    imageUrl: 'https://readdy.ai/api/search-image?query=esports%20gaming%20arena%20with%20dramatic%20dark%20lighting%20and%20red%20accents%2C%20professional%20gaming%20setup%2C%20intense%20competitive%20atmosphere%2C%20warm%20crimson%20stage%20lights%2C%20editorial%20sports%20photography%2C%20clean%20background%2C%20high%20contrast&width=800&height=600&seq=matrix-04&orientation=landscape',
    date: '2026-07-04',
    views: '52.1万',
    comments: '1.9万'
  },
  {
    id: 'm5',
    title: '某美妆博主被粉丝扒出卖假货，直播间人数骤降90%',
    category: '美妆翻车',
    imageUrl: 'https://readdy.ai/api/search-image?query=cosmetics%20and%20makeup%20products%20scattered%20on%20white%20surface%20with%20dramatic%20overhead%20lighting%2C%20beauty%20product%20review%20concept%2C%20warm%20soft%20tones%2C%20clean%20minimal%20aesthetic%2C%20editorial%20beauty%20photography%2C%20high%20detail&width=800&height=600&seq=matrix-05&orientation=landscape',
    date: '2026-07-03',
    views: '73.4万',
    comments: '3.1万'
  },
  {
    id: 'm6',
    title: '幕后真相！某综艺节目嘉宾人设全是剧本安排的',
    category: '综艺爆料',
    imageUrl: 'https://readdy.ai/api/search-image?query=television%20production%20studio%20behind%20the%20scenes%20with%20cameras%20and%20equipment%2C%20film%20set%20atmosphere%2C%20warm%20studio%20lighting%2C%20professional%20broadcast%20environment%2C%20editorial%20photography%2C%20clean%20composition%2C%20documentary%20style&width=800&height=600&seq=matrix-06&orientation=landscape',
    date: '2026-07-02',
    views: '41.6万',
    comments: '1.5万'
  }
];

export const videoArticles = [
  {
    id: 'v1',
    title: '网红直播意外录屏：说漏嘴爆料圈内潜规则',
    category: '直播录屏',
    imageUrl: 'https://readdy.ai/api/search-image?query=smartphone%20screen%20showing%20live%20streaming%20interface%20with%20dramatic%20expression%2C%20dark%20surroundings%2C%20warm%20screen%20glow%2C%20social%20media%20broadcast%20concept%2C%20editorial%20tech%20photography%2C%20clean%20dark%20background%2C%20high%20contrast%2C%20cinematic%20lighting&width=800&height=800&seq=video-01&orientation=squarish',
    duration: '03:25'
  },
  {
    id: 'v2',
    title: '独家！狗仔队跟拍三个月终于拍到实锤画面',
    category: '独家视频',
    imageUrl: 'https://readdy.ai/api/search-image?query=night%20street%20photography%20with%20telephoto%20lens%20perspective%2C%20urban%20surveillance%20concept%2C%20dark%20alley%20with%20warm%20street%20lamp%20glow%2C%20paparazzi%20style%2C%20editorial%20investigative%20photography%2C%20moody%20atmosphere%2C%20clean%20composition&width=800&height=800&seq=video-02&orientation=squarish',
    duration: '08:12'
  },
  {
    id: 'v3',
    title: '粉丝现场实拍：某男团成员后台与经纪人激烈争吵',
    category: '粉丝投稿',
    imageUrl: 'https://readdy.ai/api/search-image?query=concert%20backstage%20area%20with%20dramatic%20shadow%20lighting%2C%20music%20performance%20venue%20behind%20scenes%2C%20warm%20stage%20light%20spilling%2C%20tense%20atmosphere%2C%20editorial%20music%20photography%2C%20clean%20dark%20background%2C%20high%20emotional%20tension&width=800&height=800&seq=video-03&orientation=squarish',
    duration: '02:48'
  }
];

export const reviews = [
  {
    id: 'r1',
    name: '吃瓜群众老王',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20middle%20aged%20Chinese%20man%20in%20casual%20setting%2C%20warm%20natural%20lighting%2C%20friendly%20expression%2C%20clean%20neutral%20background%2C%20editorial%20portrait%20photography%2C%20soft%20shadows%2C%20high%20quality&width=120&height=120&seq=avatar-01&orientation=squarish',
    role: '资深吃瓜人',
    content: '这个瓜我吃了三天了，越挖越深，感觉后面还有更大的料要爆出来！建议大家持续关注，不要错过后续发展。'
  },
  {
    id: 'r2',
    name: '八卦研究员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20young%20Chinese%20woman%20in%20modern%20office%2C%20warm%20lighting%2C%20confident%20expression%2C%20clean%20cream%20background%2C%20editorial%20portrait%20photography%2C%20soft%20natural%20light%2C%20high%20quality&width=120&height=120&seq=avatar-02&orientation=squarish',
    role: '深度分析',
    content: '从时间线来看，这件事情绝对不是偶然的，背后肯定有团队在操作。我已经整理了完整的事件脉络，大家可以看我主页。'
  },
  {
    id: 'r3',
    name: '娱乐圈小喇叭',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20young%20Chinese%20man%20with%20stylish%20appearance%2C%20warm%20studio%20lighting%2C%20friendly%20smile%2C%20clean%20beige%20background%2C%20editorial%20portrait%20photography%2C%20soft%20shadows%2C%20high%20quality&width=120&height=120&seq=avatar-03&orientation=squarish',
    role: '前线爆料',
    content: '据我所知，下周还会有更重磅的消息出来，涉及到的明星咖位比现在这个还要大，大家拭目以待吧！'
  },
  {
    id: 'r4',
    name: '真相挖掘机',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20Chinese%20woman%20in%20her%2030s%2C%20warm%20natural%20light%2C%20serious%20expression%2C%20clean%20warm%20background%2C%20editorial%20portrait%20photography%2C%20soft%20lighting%2C%20high%20quality&width=120&height=120&seq=avatar-04&orientation=squarish',
    role: '资深编辑',
    content: '作为在娱乐圈摸爬滚打十年的老编辑，我可以负责任地说，这次爆料的真实性相当高。圈内很多人都知道只是不敢说。'
  },
  {
    id: 'r5',
    name: '夜猫子吃瓜',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20young%20Asian%20man%20with%20glasses%2C%20warm%20lighting%2C%20thoughtful%20expression%2C%20clean%20neutral%20background%2C%20editorial%20portrait%20photography%2C%20soft%20shadows%2C%20high%20quality&width=120&height=120&seq=avatar-05&orientation=squarish',
    role: '深夜追踪',
    content: '半夜三点爆的料，我刚好在线，第一时间截图保存了。现在原帖已经被删了，但我这里有完整备份！'
  }
];

export const hotTags = [
  { name: '网红翻车', count: '2.3万' },
  { name: '明星塌房', count: '1.8万' },
  { name: '直播带货', count: '1.5万' },
  { name: '偶像恋爱', count: '1.2万' },
  { name: '综艺剧本', count: '9800' },
  { name: '学历造假', count: '8600' }
];

export const navCategories = [
  { name: '网红爆料', slug: 'wanghong-baoliao' },
  { name: '明星黑料', slug: 'mingxing-heiliao' },
  { name: '直播翻车', slug: 'zhibo-fanche' },
  { name: '电竞黑料', slug: 'dianjing-heiliao' },
  { name: '偶像塌房', slug: 'ouxiang-tafang' },
  { name: '综艺爆料', slug: 'zongyi-baoliao' }
];

export const footerLinks = {
  categories: [
    { name: '网红爆料', href: '/category/wanghong-baoliao' },
    { name: '明星黑料', href: '/category/mingxing-heiliao' },
    { name: '直播翻车', href: '/category/zhibo-fanche' },
    { name: '电竞黑料', href: '/category/dianjing-heiliao' },
    { name: '偶像塌房', href: '/category/ouxiang-tafang' }
  ],
  about: [
    { name: '关于我们', href: '/about' },
    { name: '联系方式', href: '/about#contact' },
    { name: '投稿爆料', href: '/about#submit' },
    { name: '隐私政策', href: '/privacy' },
    { name: '用户协议', href: '/terms' }
  ],
  social: [
    { name: '微博', icon: 'ri-weibo-line', href: '#' },
    { name: '微信公众号', icon: 'ri-wechat-line', href: '#' },
    { name: '抖音', icon: 'ri-tiktok-line', href: '#' }
  ]
};